<template>
  <div class="splash" ref="splash">
    <canvas ref="canvas" class="splash-canvas"></canvas>

    <div class="splash-content" :class="{ visible: contentVisible }">

      <div class="matrix-rain" ref="matrixRain"></div>

      <div class="top-bar">
        <span class="top-bar-text">NEXTUP WEALTH MANAGEMENT</span>
        <span class="top-bar-sep">|</span>
        <span class="top-bar-text">BENEVOLISM<span class="accent">::</span>ALGO</span>
        <span class="top-bar-right">
          <span class="blink-dot"></span>
          SECURE SESSION
        </span>
      </div>

      <div class="center-block">
        <div class="pre-label">INITIALIZING</div>

        <div class="logo-lockup">
          <div class="logo-main">
            <span class="logo-nw">NW</span>
            <div class="logo-divider"></div>
            <div class="logo-right">
              <span class="logo-company">NextUp</span>
              <span class="logo-sub">Wealth Management</span>
            </div>
          </div>
          <div class="logo-tag">
            BENEVOLISM<span class="accent">::</span>ALGO — ENGINE v4.2.1
          </div>
        </div>

        <div class="progress-block">
          <div class="progress-track">
            <div class="progress-fill" ref="progressFill"></div>
            <div class="progress-glow" ref="progressGlow"></div>
          </div>
          <div class="progress-labels">
            <span class="progress-pct" ref="progressPct">0%</span>
            <span class="progress-status" ref="progressStatus">LOADING MODULES</span>
          </div>
        </div>

        <div class="boot-log" ref="bootLog">
          <div
            v-for="(line, i) in visibleLogs"
            :key="i"
            class="log-line"
            :class="line.type"
          >
            <span class="log-time">{{ line.time }}</span>
            <span class="log-prefix">{{ line.prefix }}</span>
            <span class="log-text">{{ line.text }}</span>
          </div>
        </div>
      </div>

      <div class="bottom-bar">
        <span class="bottom-left">
          <span class="accent">© {{ year }}</span> NEXTUP WEALTH MANAGEMENT
        </span>
        <span class="bottom-center">PRIVATE. PROPRIETARY. PERMANENT.</span>
        <span class="bottom-right">SYS<span class="accent">::</span>BENEVOLISM-v3</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SplashScreen',
  data() {
    return {
      year: new Date().getFullYear(),
      contentVisible: false,
      visibleLogs: [],
      allLogs: [
        { time: '00:00:001', prefix: '[BOOT]', text: 'Initializing benevolism_engine.py...', type: 'info' },
        { time: '00:00:043', prefix: '[SYS] ', text: 'Allocating execution context...', type: 'dim' },
        { time: '00:00:091', prefix: '[OK]  ', text: 'Risk framework loaded', type: 'success' },
        { time: '00:00:138', prefix: '[OK]  ', text: 'Zero-emotion execution model: ACTIVE', type: 'success' },
        { time: '00:00:204', prefix: '[SYS] ', text: 'Connecting to benevolism.fund()...', type: 'dim' },
        { time: '00:00:312', prefix: '[OK]  ', text: 'Surplus routing configured', type: 'success' },
        { time: '00:00:489', prefix: '[ALGO]', text: 'Strategy benevolism_v3: ARMED', type: 'info' },
        { time: '00:00:601', prefix: '[OK]  ', text: 'External access: NONE', type: 'success' },
        { time: '00:00:744', prefix: '[SYS] ', text: 'Horizon: indefinite', type: 'dim' },
        { time: '00:00:891', prefix: '[INIT]', text: 'System ready. Redirecting...', type: 'accent' },
      ],
      statusSteps: [
        { pct: 10, label: 'LOADING MODULES' },
        { pct: 28, label: 'INITIALIZING ALGO ENGINE' },
        { pct: 47, label: 'CONFIGURING RISK FRAMEWORK' },
        { pct: 63, label: 'CONNECTING BENEVOLISM PROTOCOL' },
        { pct: 79, label: 'ARMING STRATEGY v3' },
        { pct: 93, label: 'VERIFYING SECURE SESSION' },
        { pct: 100, label: 'SYSTEM READY' },
      ],
    }
  },
  mounted() {
    this.initCanvas()
    setTimeout(() => { this.contentVisible = true }, 100)
    this.runBootSequence()
    setTimeout(() => {
      this.$emit('done')
    }, 6000)
  },
  methods: {
    initCanvas() {
      const canvas = this.$refs.canvas
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight

      const step = 48
      ctx.strokeStyle = 'rgba(0, 245, 212, 0.04)'
      ctx.lineWidth = 0.5
      for (let x = 0; x < canvas.width; x += step) {
        ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, canvas.height); ctx.stroke()
      }
      for (let y = 0; y < canvas.height; y += step) {
        ctx.beginPath(); ctx.moveTo(0, y); ctx.lineTo(canvas.width, y); ctx.stroke()
      }
      ctx.fillStyle = 'rgba(0, 245, 212, 0.08)'
      for (let x = 0; x < canvas.width; x += step) {
        for (let y = 0; y < canvas.height; y += step) {
          if (Math.random() > 0.88) {
            ctx.beginPath(); ctx.arc(x, y, 1, 0, Math.PI * 2); ctx.fill()
          }
        }
      }
    },

    runBootSequence() {
      const fill = this.$refs.progressFill
      const glow = this.$refs.progressGlow
      const pct = this.$refs.progressPct
      const status = this.$refs.progressStatus

      this.statusSteps.forEach((step, i) => {
        setTimeout(() => {
          if (fill) fill.style.width = step.pct + '%'
          if (glow) glow.style.left = step.pct + '%'
          if (pct) pct.textContent = step.pct + '%'
          if (status) status.textContent = step.label
        }, i * 700)
      })

      this.allLogs.forEach((log, i) => {
        setTimeout(() => {
          this.visibleLogs.push(log)
          const el = this.$refs.bootLog
          if (el) el.scrollTop = el.scrollHeight
        }, 300 + i * 480)
      })
    },
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600&family=JetBrains+Mono:wght@300;400;500&display=swap');

* { box-sizing: border-box; margin: 0; padding: 0; }

.splash {
  position: fixed;
  inset: 0;
  background: #030b0e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'JetBrains Mono', monospace;
  overflow: hidden;
  z-index: 9999;
}

.splash-canvas {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.splash-content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  opacity: 0;
  transition: opacity 0.6s ease;
}

.splash-content.visible { opacity: 1; }

.top-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 40px;
  border-bottom: 0.5px solid rgba(0, 245, 212, 0.15);
  font-size: 10px;
  letter-spacing: 0.14em;
  color: rgba(226, 244, 240, 0.5);
  background: rgba(3, 11, 14, 0.8);
}

.top-bar-sep { color: rgba(0, 245, 212, 0.3); }

.top-bar-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(0, 245, 212, 0.7);
}

.blink-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #00f5d4;
  animation: blink 1.2s step-end infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

.center-block {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  padding: 40px;
}

.pre-label {
  font-size: 10px;
  letter-spacing: 0.2em;
  color: rgba(0, 245, 212, 0.5);
  animation: fadeSlideDown 0.8s ease both;
}

@keyframes fadeSlideDown {
  from { opacity: 0; transform: translateY(-10px); }
  to   { opacity: 1; transform: translateY(0); }
}

.logo-lockup {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  animation: fadeSlideUp 0.9s ease 0.2s both;
}

@keyframes fadeSlideUp {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

.logo-main {
  display: flex;
  align-items: center;
  gap: 20px;
}

.logo-nw {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 56px;
  font-weight: 600;
  color: #00f5d4;
  letter-spacing: -0.04em;
  line-height: 1;
}

.logo-divider {
  width: 1px;
  height: 52px;
  background: rgba(0, 245, 212, 0.3);
}

.logo-right {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.logo-company {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 28px;
  font-weight: 500;
  color: #e2f4f0;
  letter-spacing: -0.02em;
  line-height: 1;
}

.logo-sub {
  font-family: 'Space Grotesk', sans-serif;
  font-size: 13px;
  font-weight: 300;
  color: rgba(226, 244, 240, 0.6);
  letter-spacing: 0.06em;
}

.logo-tag {
  font-size: 10px;
  letter-spacing: 0.14em;
  color: rgba(0, 245, 212, 0.5);
}

.progress-block {
  width: 100%;
  max-width: 520px;
  animation: fadeIn 0.8s ease 0.5s both;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.progress-track {
  position: relative;
  height: 2px;
  background: rgba(226, 244, 240, 0.08);
  border-radius: 2px;
  overflow: visible;
  margin-bottom: 10px;
}

.progress-fill {
  position: absolute;
  left: 0; top: 0;
  height: 100%;
  width: 0%;
  background: #00f5d4;
  border-radius: 2px;
  transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 0 8px rgba(0, 245, 212, 0.6);
}

.progress-glow {
  position: absolute;
  top: 50%;
  left: 0%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0,245,212,0.8) 0%, transparent 70%);
  transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
}

.progress-labels {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.progress-pct {
  font-size: 11px;
  color: #00f5d4;
  letter-spacing: 0.08em;
}

.progress-status {
  font-size: 10px;
  color: rgba(226, 244, 240, 0.5);
  letter-spacing: 0.12em;
}

.boot-log {
  width: 100%;
  max-width: 520px;
  height: 160px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 6px;
  animation: fadeIn 0.8s ease 0.7s both;
}

.log-line {
  display: flex;
  gap: 12px;
  font-size: 11px;
  line-height: 1.4;
  animation: logFade 0.3s ease both;
}

@keyframes logFade {
  from { opacity: 0; transform: translateX(-6px); }
  to   { opacity: 1; transform: translateX(0); }
}

.log-time {
  color: rgba(226, 244, 240, 0.25);
  min-width: 80px;
}

.log-prefix { min-width: 48px; }

.log-line.info .log-prefix  { color: #00f5d4; }
.log-line.info .log-text    { color: rgba(226, 244, 240, 0.8); }
.log-line.success .log-prefix { color: #39ff14; }
.log-line.success .log-text   { color: rgba(226, 244, 240, 0.75); }
.log-line.dim .log-prefix   { color: rgba(226, 244, 240, 0.35); }
.log-line.dim .log-text     { color: rgba(226, 244, 240, 0.45); }
.log-line.accent .log-prefix { color: #00f5d4; }
.log-line.accent .log-text   { color: #00f5d4; }

.bottom-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 40px;
  border-top: 0.5px solid rgba(0, 245, 212, 0.1);
  font-size: 10px;
  letter-spacing: 0.1em;
  color: rgba(226, 244, 240, 0.35);
  background: rgba(3, 11, 14, 0.8);
}

.bottom-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  letter-spacing: 0.18em;
  color: rgba(226, 244, 240, 0.2);
}

.accent { color: #00f5d4; }
</style>
